import styled from 'styled-components';
import { Button } from 'junto-ui';
import {
  tokens,
  EndorsamentIcon as Endorsement,
  palette
} from '@plataforma/components';
import { colors, fonts, grid } from '_/styles';

export const Wrapper = styled.div`
  margin-bottom: ${grid.regular};
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  min-height: 96px;
  color: ${colors.textMain};
  border: 1px solid ${colors.divider};
  border-radius: ${grid.radius};
  padding: ${grid.regular} ${grid.regular} ${grid.regular} ${grid.medium};
`;

export const DocumentNumber = styled.p`
  color: ${colors.textMain};

  font-weight: ${tokens.font.weight.semibold};
  font-size: 16px;
`;

export const Date = styled.p`
  color: ${colors.textComplementary};
  font-size: ${fonts.size.default};
`;

export const Description = styled.p`
  color: ${colors.textMain};
  font-size: ${fonts.size.default};
`;

export const Group = styled.div`
  width: 180px;
`;

export const EndorsementIcon = styled(Endorsement)`
  margin-right: ${grid.medium};
`;

export const ActionButton = styled(Button)`
  width: 152px;
  margin-left: auto;
  font-family: ${tokens.font.family.metropolis};
  font-weight: ${tokens.font.weight.semibold};
`;

export const Warning = styled.div`
  background: ${colors.surface};
  border: 1px solid ${colors.divider};
  border-bottom-left-radius: ${grid.radius};
  border-bottom-right-radius: ${grid.radius};
  padding: ${grid.regular};
  position: relative;
  top: -${grid.radius};
  white-space: nowrap;

  p {
    color: ${colors.textMain};
  }

  ${({ internalized }) =>
    internalized &&
    `
    background: ${colors.baseBlueLight};
    p { color: ${colors.baseBlue}; }
  `}
`;

export const WarningText = styled.p`
  color: ${colors.textMain};
  font-size: ${fonts.size.default};
  font-weight: ${tokens.font.weight.semibold};
`;

export const DownloadButton = styled.div`
  margin-left: 28px;
  color: ${colors.electricViolet};
  font-weight: ${tokens.font.weight.semibold};
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: start;
  cursor: pointer;
  width: 127px;
  svg {
    margin-right: 8px;
  }
`;

export const labelButtonDownload = styled.span`
  color: ${palette['color-brand-primary']};
  ${tokens.font['xs-emphasys']};
`;
